// extracted by mini-css-extract-plugin
export default {"DraggableCard":"bfj_a"};